import React from "react";
import Button from "../../../../components/Button/Button";
import styles from "./kyc.module.scss";
import checkedImg from '../../../../assets/images/extras/checked.png';
import unCheckedImg from '../../../../assets/images/extras/cross.png';
import { useSubmitKyc } from "../../../../hooks/partnerHook/usePartnerKyc";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function Review({ formData, setActiveNav }) {
    const navigate = useNavigate()
    const userData = useSelector((state) => state.partner.user);
    const partnerId = userData?.partner?.id;
    const reviewData = {
        "First Name": formData.firstName,
        "Last Name": formData.lastName,
        "Phone Number": formData.phoneNumber,
        'Email': formData.email,
        "Document Origin": formData.documentCountry,
        "Document Type": formData.documentType,
        "Document Number": formData.documentNumber,
    };
    const {mutate: submitKycHook, isError, isPending} = useSubmitKyc(navigate)
    const handleFormSubmission = async(e) => {
        e.preventDefault();
        const {documentImg,selfieImg, ...kycData } = formData;
        console.log('Form data to submit: ', kycData);
        await submitKycHook({partnerId, kycData});
        
    }

    return (
        <div className={styles.reviewContainer}>
            <div className={styles.kycDetails}>
                {Object.keys(reviewData).map((key) => (
                    <div className={styles.detailRow}>
                        <p className={styles.rowKey}>{key} : </p>
                        <p className={styles.rowValue}>{reviewData[key]}</p>
                    </div>
                ))}

                <div className={styles.mediaUploadStatus}>
                    <p> <img src={formData.documentUrl ? checkedImg : unCheckedImg} alt="" />  Document uploaded</p>
                    <p> <img src={formData.documentUrl ? checkedImg : unCheckedImg} alt="" /> Selfie uploaded</p>
                </div>
            </div>
            <div className={styles.btnContainer}>
                <Button label={"Back"} handleClick={() => setActiveNav(3)} />
                <Button label={isPending ? 'Submitting': "Submit For Verification"} disabled={isPending} type="submit" handleClick={handleFormSubmission} />
            </div>
        </div>
    );
}

export default Review;
